import { global } from "../../constants";

export const data = {
  banner: {
    base: "Servicios",
    background: global.banner + "maritime-law.webp",
    title: "Derecho Marítimo",
    crumb: "Derecho Marítimo",
  },
  icon: "fa-solid fa-gavel",
  shortDescription:
    "Asesoría legal especializada en operaciones marítimas, contratos y cumplimiento normativo.",

  title: "Derecho Marítimo",
  features: {
    title: "Derecho Marítimo",
    deliverables: "Entregables",
    reqDocuments: "Documentos Requeridos",
    subtitle: "Asesoría legal especializada en operaciones marítimas, contratos y cumplimiento normativo.",
    description: `Asesoría integral en Derecho Marítimo: redacción y negociación de contratos, trámites registrales, fletamentos, due diligence en compra/venta y asesoría laboral marítima.`,
    viewDetail: "Ver Detalles",
    feats: [
      {
        key: "contratos",
        title: "Redacción y negociación de contratos marítimos a la medida",
        summary:
          "Contratos (fletamento, agencia, reparación, servicios portuarios) con clausulado de responsabilidad, seguros y arbitraje.",
        details:
          "Redacción a medida, revisión de cláusulas críticas (laytime, demurrage, P&I, fuerza mayor), negociación y propuesta de alternativas para mitigar riesgos.",
        deliverables: [
          "Borrador legal (Word/PDF)",
          "Resumen ejecutivo de cláusulas críticas",
          "Checklist de riesgos",
        ],
        requiredDocs: [
          "Datos de las partes",
          "Términos comerciales previos",
          "Documentación técnica de la operación",
        ],
        icon: "fa-solid fa-file-contract",
        image: global.services + "editorial.jpeg",
      },
      {
        key: "registro",
        title: "Gestión y trámites ante el Registro Naval Venezolano",
        summary:
          "Inscripción, transferencias, anotaciones de gravámenes y gestión documental ante el Registro Naval.",
        details:
          "Preparación de expediente, presentación ante autoridad, seguimiento y obtención de certificados registrales; coordinación con peritos y técnicos si es necesario.",
        deliverables: [
          "Expediente listo",
          "Comprobante de radicado",
          "Certificado final entregado",
        ],
        requiredDocs: [
          "Títulos de propiedad",
          "Poderes notariales",
          "Certificados técnicos del buque",
        ],
        icon: "fa-solid fa-passport",
        image: global.services + "consulting.webp",
      },
      {
        key: "fletamento",
        title: "Asesoría en fletamento (time & voyage charter)",
        summary:
          "Negociación y redacción de contratos de fletamento, cálculo laytime y manejo de reclamaciones de demurrage.",
        details:
          "Asesoría para elegir tipo de fletamento, redacción de cláusulas operativas, cálculo y ejemplos de laytime/demurrage, y procedimientos de notificación.",
        deliverables: [
          "Contrato/cláusulas de fletamento",
          "Cálculo ejemplo de laytime",
          "Procedimiento de gestión de reclamaciones",
        ],
        requiredDocs: [
          "Itinerario previsto",
          "Documentación del buque",
          "Condiciones comerciales",
        ],
        icon: "fa-solid fa-anchor",
        image: global.services + "management.jpg",
      },
      {
        key: "compraventa",
        title: "Compra y venta de embarcaciones: due diligence y contrato",
        summary:
          "Due diligence legal y técnica, redacción de SPA, gestión de escrow y transferencia registral.",
        details:
          "Verificación de gravámenes, certificados técnicos, historial de mantenimiento; coordinación de inspecciones y cláusulas de indemnidad y escrow en el contrato.",
        deliverables: [
          "Informe de due diligence",
          "Borrador de compraventa",
          "Plan de transferencia",
        ],
        requiredDocs: [
          "Títulos registrales",
          "Historial de mantenimiento",
          "Certificados técnicos",
        ],
        icon: "fa-solid fa-ship",
        image: global.services + "purchase.jpeg",
      },
      {
        key: "laboral",
        title: "Asesoría en derecho laboral marítimo y solución de conflictos",
        summary:
          "Contratos de tripulantes, reclamaciones laborales, cumplimiento de convenios y representación en disputas.",
        details:
          "Redacción de contratos laborales marítimos, protocolos de reclamación, representación en trámites administrativos y judiciales, gestión preventiva de riesgos laborales a bordo.",
        deliverables: [
          "Plantilla de contrato laboral",
          "Procedimiento de reclamación",
          "Soporte en negociaciones",
        ],
        requiredDocs: [
          "Contratos actuales",
          "Certificados de competencia",
          "Historial de incidentes",
        ],
        icon: "fa-solid fa-people-roof",
        image: global.services + "labor-law.jpg",
      },
    ],
  },
  ctaText: "Solicitar asesoría legal",
  ctaLink: "/contacto?servicio=derecho-maritimo",
};
